/* Built In Imports */
import { Box, useTheme, Flex, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import React from 'react';
import { nanoid } from 'nanoid';

import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';

const Highlights = ({ sectionContent, lang }) => {
  const theme = useTheme();
  const spacing = theme.space[5];
  return (
    <Box
      bgColor={'#00052F'}
      p={{ base: '60px 0px 20px 0px', lg: '60px 20px' }}
      display={'flex'}
      justifyItems={'center'}
      flexDirection={'column'}
      alignItems={'center'}
    >
      <MsrSectionTitle
        fontSize={{ base: '24px', md: '38px'}}
        pt="0"
        mt="0"
        titleObj={sectionContent[0]}
        pageName="tamilthembu"
        fontWeight={lang == "ta" ? "600" : "500"}
        fontFamily = {lang == "ta"? "MuktaMalar" : "FedraSerifAStdBook"}
      />
      <Box
        maxW={{ base: '90%', md: lang == "ta" ? "600px" : '494px' }}
        mt={{ base: '-20px', md: '-20px', lg: '-20px' }}
        lineHeight={{ base: '27px', md: '27px', lg: '27px' }}
        textAlign={"center"}
      >
        <StructuredTextParser
          str={render(sectionContent[1]?.body)}
          lang={lang}
          textAlign={"center"} 
          fontFamily={lang=="ta" ? "MuktaMalar" : 'FedraSansStd-book'}
          fontWeight={"400"}
          fontSize={"16px"}
          pageName="tamilthembu"
          color="#FFF7E9"
          className="desctext1"
        />
      </Box>
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        marginX={`calc(${spacing} / -2)`}
        flexDir={{ base: 'row', md: 'row' }}
        display={{ base: 'block', md: 'flex' }}
        m="30px auto 0 auto"
      >
        {sectionContent[2]?.cards?.map((secCon, _) => {
          return (
            <Flex
              key={nanoid()}             
              flexGrow="0"
              flexDirection="column"
              flexShrink="0"
              flexBasis={`calc(33% - ${spacing})`}
              marginBottom={spacing}
              _even={{
                marginX: spacing,
              }}
              py={{ base: '10px', md: '25px' }}
              alignItems={'center'}
              mt={{base:'20px', md:'0'}}
            >
              <Box maxW={{ base: '100%', md: '100%'}}>
              <LazyLoadImageComponent
                src={secCon.thumbnail?.url}
                alt={secCon.thumbnail?.alt}
                title={secCon.thumbnail?.title}
                pb={'15px'}
                w={'178px'}
              />
              </Box>
              <Box maxW={{base:'284px', md:'372px'}} justifyItems={'center'}>
              <Text
                  fontSize={{ base: '20px', md: '26px' }}
                  color={'#FFF7E9'}
                  fontWeight= {'600'}
                  textAlign="center"
                  lineHeight={{ base: '25.5px', md: '33px' }}
                  width={{base: lang == "ta" ? "" : "260px", md: lang == "ta" ? "" : "237px" }}
                  fontFamily={lang=="ta" ? "MuktaMalar" : 'FedraSerifAStdBook'}
                >
                  {secCon.title}
                </Text>
                <Box
                  pt={0}
                  m={{ base: '10px auto 0 auto', md: '10px auto 0 auto' }}
                >
                  <StructuredTextParser
                    str={render(secCon.description)}
                    mt="0"
                    textAlign="center"
                    lang={lang}
                    className="desctext"
                    fontWeight={"400"}
                    color={'#FFFFFF'}
                    fontFamily={lang == "ta" ? "MuktaMalar" : "FedraSansStd-book"}
                    pageName="tamilthembu"
                  />
                </Box>
              </Box>
            </Flex>
          );
        })}
      </Flex>
      <style jsx global>
        {`
          .desctext1 p {
            line-height: 27.2px;
          }
          .desctext p {
            color: #ffffff;
            font-size: 18px;
            line-height: 21.6px;
          }
          @media (max-width: 768px) {
            .desctext p {
              font-size: 16px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Highlights;
